module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/runner/work/webapp/webapp/node_modules/style-loader/index.js!/home/runner/work/webapp/webapp/node_modules/css-loader/index.js??ref--12-2!/home/runner/work/webapp/webapp/vendor/semantic/dist/semantic.min.css"));
    }, "semantic-css");
  });
}